var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"display":"flex","justify-content":"center","margin":"20px 0"}},[_c('iframe',{staticStyle:{"width":"1300px","height":"800px","border-radius":"16px","box-shadow":"0 4px 12px rgba(0,0,0,0.1)","border":"none","background-color":"#fff"},attrs:{"src":"http://119.45.200.53/page/JBrowse/"}})])])
}]

export { render, staticRenderFns }